import { ActivatedRouteSnapshot, BaseRouteReuseStrategy, DetachedRouteHandle } from '@angular/router';

export class CustomRouteReuseStrategy implements BaseRouteReuseStrategy {
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void { }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return false;
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle {
    return null;
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const futureOrganization = future.paramMap.get('organizationName');
    const currOrganization = curr.paramMap.get('organizationName');
    const futureTenant = future.paramMap.get('tenantUrlName');
    const currTenant = curr.paramMap.get('tenantUrlName');
    return future.routeConfig === curr.routeConfig && futureOrganization === currOrganization && futureTenant === currTenant;
  }
}
